module.exports = __webpack_public_path__ + "img/default.3e96a6b.png";